// Vendors
import { useState, useCallback, useEffect } from "react";
import { useForm } from "@mantine/form";
import {
  LoadingOverlay,
  Grid,
  MediaQuery,
  Title,
  TextInput,
  Button,
  Alert,
  Box,
} from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons";
import image from "../../assets/logo/ticketin-darkmode.svg";
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import { useNavigate } from "react-router-dom";
import { apiWithoutInterceptor } from "../../api";

// Utils
import { login } from "../../api/auth";

export default function Login() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const particlesInit = useCallback(async (engine) => {
    await loadFull(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {}, []);
  const navigate = useNavigate();

  useEffect(() => {
    apiWithoutInterceptor
      .get("/auth/check", {
        headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`,
        },
      })
      .then(() => {
        navigate("/app/events/all");
      })
      .catch((err) => {
        console.log(err);
        localStorage.setItem("token", JSON.stringify(null));
        localStorage.setItem("userInfo", JSON.stringify(null));
        navigate("/", { replace: true });
      });

    if (JSON.parse(localStorage.getItem("token")) === null) {
      navigate("/", { replace: true });
    }
  }, []);

  const form = useForm({
    initialValues: { email: "", password: "" },
    validate: {
      email: (value) => (/^\S+@\S+\.\S+$/.test(value) ? null : "Invalid email"),
      password: (value) => (value.length < 4 ? "Password is very short" : null),
    },
  });

  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <Grid sx={{ height: "102vh", alignContent: "center" }}>
        <Grid.Col
          xs={12}
          sm={6}
          md={5}
          lg={3}
          sx={{ zIndex: "3", backgroundColor: "white" }}
        >
          <Grid sx={{ alignItems: "center", height: "100%" }}>
            <Grid.Col xs={12}>
              <Box
                sx={{
                  width: "100%",
                  textAlign: "center",
                  textTransform: "uppercase",
                }}
              >
                <Title order={1}>Login</Title>
              </Box>
              <div style={{ position: "relative" }}>
                <form
                  style={{ padding: 30 }}
                  onSubmit={form.onSubmit((vals) => {
                    setLoading(true);

                    login(vals.email, vals.password)
                      .then((res) => {
                        localStorage.setItem(
                          "token",
                          JSON.stringify(res.data.token)
                        );
                        localStorage.setItem(
                          "userInfo",
                          JSON.stringify(res.data.user)
                        );
                        // setTokenLocalStorage(res.data.token);
                        // setUserInfoLocalStorage(res.data.user);
                        // dispatch(setTokenRedux(res.data.token));
                        // dispatch(setUserRedux(res.data.user));

                        navigate("/app/events/all", { replace: true });
                      })
                      .catch((err) => {
                        setError(err?.response?.data?.message);
                      })
                      .finally(() => {
                        setLoading(false);
                      });
                  })}
                >
                  {Boolean(error?.length) && (
                    <Alert
                      sx={{ marginBottom: 20 }}
                      icon={<IconAlertCircle size={16} />}
                      color="red"
                      variant="filled"
                    >
                      {error}
                    </Alert>
                  )}
                  <LoadingOverlay visible={loading} overlayBlur={2} />
                  <TextInput
                    label="Email"
                    placeholder="Email"
                    {...form.getInputProps("email")}
                  />
                  <TextInput
                    mt="sm"
                    label="Password"
                    placeholder="Password"
                    type="password"
                    {...form.getInputProps("password")}
                  />
                  <Button type="submit" mt="sm">
                    Sign In
                  </Button>
                </form>
              </div>
            </Grid.Col>
          </Grid>
        </Grid.Col>
        <MediaQuery smallerThan={"sm"} styles={{ display: "none" }}>
          <Grid.Col
            xs={12}
            sm={6}
            md={7}
            lg={9}
            sx={{
              backgroundSize: "cover",
              backgroundColor: "#525050",
              backgroundPosition: "center",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Particles
              id="tsparticles"
              init={particlesInit}
              loaded={particlesLoaded}
              options={{
                particles: {
                  number: {
                    value: 200,
                    density: {
                      enable: false,
                      value_area: 800,
                    },
                  },
                  color: {
                    value: "#edb40d",
                  },
                  shape: {
                    type: "circle",
                    stroke: {
                      width: 0,
                      color: "#000000",
                    },
                    polygon: {
                      nb_sides: 5,
                    },
                    image: {
                      src: "img/github.svg",
                      width: 100,
                      height: 100,
                    },
                  },
                  opacity: {
                    value: 0.5,
                    random: true,
                    anim: {
                      enable: false,
                      speed: 1,
                      opacity_min: 0.1,
                      sync: false,
                    },
                  },
                  size: {
                    value: 5,
                    random: true,
                    anim: {
                      enable: false,
                      speed: 40,
                      size_min: 0.1,
                      sync: false,
                    },
                  },
                  line_linked: {
                    enable: false,
                    distance: 500,
                    color: "#ffffff",
                    opacity: 0.4,
                    width: 2,
                  },
                  move: {
                    enable: true,
                    speed: 1,
                    direction: "bottom",
                    random: false,
                    straight: false,
                    out_mode: "out",
                    bounce: false,
                    attract: {
                      enable: true,
                      rotateX: 600,
                      rotateY: 1200,
                    },
                  },
                },
                interactivity: {
                  detect_on: "canvas",
                  events: {
                    onhover: {
                      enable: true,
                      mode: "bubble",
                    },
                    onclick: {
                      enable: true,
                      mode: "repulse",
                    },
                    resize: true,
                  },
                  modes: {
                    grab: {
                      distance: 400,
                      line_linked: {
                        opacity: 0.5,
                      },
                    },
                    bubble: {
                      distance: 400,
                      size: 4,
                      duration: 0.3,
                      opacity: 1,
                      speed: 3,
                    },
                    repulse: {
                      distance: 200,
                      duration: 0.4,
                    },
                    push: {
                      particles_nb: 4,
                    },
                    remove: {
                      particles_nb: 2,
                    },
                  },
                },
                retina_detect: true,
                fullScreen: { zIndex: 0 },
              }}
            />
            <img style={{ zIndex: 1 }} src={image} width={500} height={200} />
          </Grid.Col>
        </MediaQuery>
      </Grid>
    </div>
  );
}
